export function kEurShort(value: string, format: 'full' | 'long' | 'number' | 'unit' = 'full') {
  if (value === "" || value === null || value === undefined || isNaN(+value)) {
    return '*';
  }

  const actualValue = Math.round(+value * 1000);
  const digitCount = actualValue.toString().length;

  const options = {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code',
    notation: 'compact',
    maximumFractionDigits: digitCount > 6 ? 1 : 0, // show fraction when value is abbreviated (starts at digit 7)
  } as Intl.NumberFormatOptions;

  const kEurShort = new Intl.NumberFormat('de-DE', options).format(actualValue);

  let number = '';
  let abbreviation = '';
  let unit = '';

  const kEurShortParts = kEurShort.split(/\s/);

  if (kEurShortParts.length === 3) {
    [number, abbreviation, unit] = kEurShortParts
  } else {
    [number, unit] = kEurShortParts
  }

  switch (format) {
    case 'number':
      return number;
    case 'unit':
      return abbreviation ? `${abbreviation} ${unit}` : unit;
    case 'long':
      return abbreviation ? `${number} ${abbreviation}` : number;
    default:
      return kEurShort;
  }
}